
import React from 'react';
import { Link } from 'react-router-dom';
import './PromotionBanner.css';

const PromotionBanner = ({ promotion, onClose }) => {
  if (!promotion) {
    return null;
  }

  return (
    <div className="promotion-banner">
      <div className="promotion-banner-content">
        <button onClick={onClose} className="promotion-banner-close">
          &times;
        </button>
        <Link to={`/eventos/${promotion.id}`} className="promotion-banner-image-link">
          <img src={promotion.graphicPieceUrl} alt={promotion.title} className="promotion-banner-image" />
        </Link>
        
        <Link to={`/eventos/${promotion.id}`} className="promotion-banner-button">
          <span className="promo-active-text">¡Promo Activa!</span>
          <span className="view-more-text">Ver Más</span>
        </Link>
      </div>
    </div>
  );
};

export default PromotionBanner;
